module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yd-news-lunbo-vertical",
    on: {
      "click": function($event) {
        _vm.newsClick(_vm.newsData.newsContentURL)
      }
    }
  }, [_c('p', {
    staticClass: "yd-title"
  }, [_vm._v(_vm._s(_vm.newsData.newsContentTitle))]), _vm._v(" "), _c('div', {
    staticClass: "yd-news-content"
  }, [_c('el-carousel', {
    attrs: {
      "trigger": "click",
      "height": "150px"
    }
  }, _vm._l((_vm.lunboSlideNum), function(i) {
    return _c('el-carousel-item', {
      key: i
    }, [(_vm.lunboImages[i - 1]) ? _c('img', {
      attrs: {
        "src": _vm.lunboImages[i - 1],
        "alt": "请输入正确的图片地址"
      }
    }) : _vm._e()])
  })), _vm._v(" "), (_vm.newsData.newsContentSource) ? _c('div', {
    staticClass: "yd-module-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newsData.newsContentSource))]), _vm._v(" "), (_vm.newsData.newsContentUpdateTime) ? _c('span', [_vm._v(_vm._s(_vm.newsData.newsContentUpdateTime))]) : _c('span', [_vm._v(_vm._s(_vm.getCurrentTime()))])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6e4a429b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/common/newsTemplate/SlidesNewsVertical.vue
// module id = 776
// module chunks = 1